<template>
<kt-row >
    <div class="col col-sm-6 col-lg-4 col-xl-3" v-bind:key="payman.id" v-for="payman in paymans">
        <kt-panel>
            <kt-panel-body class="p-0 pt-4">
                <kt-panel-header-label class="text-center">
                    <img :src="payman.logo" class="kt-badge kt-badge--xl" />
                    <kt-panel-header-title class="mt-3 text-dark">{{ payman.title }}</kt-panel-header-title>
                    <span :class="'kt-badge--'+variant(payman.status)" class="kt-badge kt-badge--dot mr-1"></span>
                    <span :class="'text-'+variant(payman.status)">{{ statusStr(payman.status) }}</span>
                    <br>
                    <span v-if="payman.status" class="d-block w-75 mx-auto mt-3 badge badge-secondary">{{ $t('label.gateway_id') + ": " + payman.sequence }}</span>
                </kt-panel-header-label>
                <router-link class="btn btn-secondary border-0 bg-secondary text-dark mt-3 btn-square" :to="'/payman/update/'+payman.id">
                    {{ $t('btn.edit') }}
                </router-link>
            </kt-panel-body>
        </kt-panel>
    </div>
</kt-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { paymanStatusStr, paymanVariant } from '@/constants/paymanStatus'

export default {
    methods:{
        ...mapActions('payman', [
            'fetch'
        ]),
        variant(status) {
            return paymanVariant(status)
        },
        statusStr(status) {
            return paymanStatusStr.get(status)
        }
    },
    mounted() {
        this.fetch()
    },
    computed: {
        ...mapGetters('payman', [
            'paymans'
        ]),
    },
}
</script>

<style>

</style>